import React from "react";
import { Flex } from "../../components/Flex";
import { SubHeader } from "../../components/SubHeader";
import { useTranslation } from "react-i18next";
import { faLifeRing } from "@fortawesome/free-solid-svg-icons/faLifeRing";
import { Text } from "../../components/Text";
import styled from "styled-components";
import { Spacing } from "../../theme/Spacing";
import { Rounded } from "../../theme/Rounded";
import { AtiraIcon } from "../../components/AtiraIcon";
import { faExternalLink } from "@fortawesome/free-solid-svg-icons/faExternalLink";
import { Button } from "../../components/Button";
import { EntityIcons } from "../../utils/GlobalIcons";
import { AtiraImage } from "../../components/Image";
import { getChatImage } from "../../utils/Media";
import { useTheme } from "../../ThemeContext";
import { useDrawersContext } from "../tasks/drawers-context";
import { faRobot } from "@fortawesome/free-solid-svg-icons/faRobot";

const Container = styled(Flex)`
  flex-direction: column;
  padding: ${Spacing.m};
  background-color: ${({ theme }) => theme.white};
  flex: 1;
  margin-inline: ${Spacing.m};
  border-radius: ${Rounded.md};
  gap: ${Spacing.xxl};
`;

export const HelpSupportRouteWithLazy: React.FC = () => {
  const { t } = useTranslation();
  const { selectedTheme } = useTheme();
  const { setFahmyMenuOpen } = useDrawersContext();

  return (
    <Flex flexDirection="column" flex={1}>
      <SubHeader title={t("helpSupport.title")} icon={faLifeRing} />
      <Container>
        <Flex flexDirection="column">
          <Flex alignItems="baseline" gap="s">
            <AtiraImage
              src={getChatImage(selectedTheme, false, null).image}
              width="4rem"
            />
            <Text>{t("helpSupport.fahmy.description")}</Text>
          </Flex>
          <Button
            hover
            width="20rem"
            icon={faRobot}
            onClick={() => setFahmyMenuOpen(true)}
          >
            {t("helpSupport.fahmy.button")}
          </Button>
        </Flex>

        <Flex flexDirection="column">
          <Flex gap="s">
            <AtiraIcon icon={EntityIcons.Forms} color="main" size="2x" />
            <Text>{t("helpSupport.form.description")}</Text>
          </Flex>
          <Button
            hover
            width="20rem"
            icon={faExternalLink}
            onClick={() =>
              window.open(
                "https://atiraspace.com/api/form/69515522bae42639c4254e63/generate",
                "_blank",
              )
            }
          >
            {t("helpSupport.form.button")}
          </Button>
        </Flex>
      </Container>
    </Flex>
  );
};
